// extracted by mini-css-extract-plugin
export default {"wrapper":"roadmap_wrapper__uH25G","content":"roadmap_content__XnkMt"};